import axios from "axios"

function getActivities({}, {}, params) {
    return axios.get(`api/activities`, { params })
}

// La même lecture que getActivities, sous un nom que les reducers n'écoutent
// pas : l'écran d'attente de la correction l'appelle toutes les 5 s, et chaque
// réponse de getActivities remplace tout l'objet de l'élève dans le store.
function pollActivityCorrection({}, {}, params) {
    return axios.get(`api/activities`, { params })
}

function getFinishedActivities({}, {}, params) {
    return axios.get(`api/activities/finished`, { params })
}

function getStudentFinishedActivities({ id }, {}, params) {
    return axios.get(`api/students/${id}/activities/finished`, { params })
}

function initActivity({}, formData, urlParams, onUploadProgress) {
    return axios.post(`api/activities`, formData, {
        onUploadProgress,
    })
}

function postActivityLogs({ id }, formData, urlParams, onUploadProgress) {
    return axios.post(`api/activities/${id}/logs`, formData, {
        onUploadProgress,
    })
}

function postActivityLog({ id }, formData, urlParams, onUploadProgress) {
    return axios.post(`api/activities/${id}/log`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
        onUploadProgress,
    })
}

function postActivityLogV1({ id }, formData, urlParams, onUploadProgress) {
    return axios.post(`api/v1/activities/${id}/log`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
        onUploadProgress,
    })
}

function deleteActivityLog({ id }, formData) {
    return axios.delete(`api/activity-logs/${id}`, { data: formData })
}

function finalizeActivity({ id }, formData = {}, urlParams, onUploadProgress) {
    return axios.post(`api/activities/${id}/finalize`, formData, {
        onUploadProgress,
    })
}

function finalizeActivitySilent(
    { id },
    formData = {},
    urlParams,
    onUploadProgress
) {
    return axios.post(`api/activities/${id}/finalize`, formData, {
        onUploadProgress,
    })
}

function tutorValidateActivity({ id }) {
    return axios.post(`api/activities/${id}/validate`)
}

function readReview({ id }) {
    return axios.post(`api/activities/${id}/read-review`)
}

function getActivitiesForReview({}, {}, params) {
    return axios.get(`api/activities/for-review`, { params })
}

function reviewActivity({ id }, formData) {
    return axios.post(`api/v1/activities/${id}/review`, formData)
}

function reviewLock({ id }) {
    return axios.post(`api/v1/activities/${id}/review-lock`)
}

function postMaterial({ activity_id }, formData) {
    return axios.post(`api/activities/${activity_id}/material`, formData)
}

function putMaterial({ id }, formData) {
    return axios.put(`api/materials/${id}`, formData)
}

function deleteMaterial({ id }) {
    return axios.delete(`api/materials/${id}`)
}

function materialsSearch({}, {}, params) {
    return axios.get(`api/materials`, { params })
}

function getMaterial({ id }) {
    return axios.get(`api/materials/${id}`)
}

function lockActivity({ id }, formData) {
    return axios.post(`api/v1/activities/${id}/lock`, formData)
}

function getActivity({ id }, {}, params) {
    return axios.get(`api/v1/activities/${id}`, { params })
}

function activityTodoAsStudent({}, formData, {}, onUploadProgress) {
    return axios.post(`api/v2/activities/todo`, formData, {
        onUploadProgress,
    })
}

function activityTodoAsTutor({ id }, formData, {}, onUploadProgress) {
    return axios.post(`api/v2/students/${id}/activities/todo`, formData, {
        onUploadProgress,
    })
}

function activityTodoForStudents({}, formData, {}, onUploadProgress) {
    return axios.post(`api/v1/students/activities/todo`, formData, {
        onUploadProgress,
    })
}

function updateActivityTodo({ id }, formData, {}, onUploadProgress) {
    return axios.put(`api/v1/activities/${id}/todo`, formData, {
        onUploadProgress,
    })
}

function activityTodoIndexesAsStudent({}, formData) {
    return axios.put(`api/v1/activities/todo/indexes`, formData)
}

function activityTodoIndexesAsTutor({ id }, formData) {
    return axios.put(`api/v1/students/${id}/activities/todo/indexes`, formData)
}

function deleteActivitiesTodo({ student }, formData) {
    return axios.delete(`api/v1/students/${student}/activities/todo`, {
        data: formData,
    })
}

function deleteCommonActivityTodo({}, {}, params) {
    return axios.delete(`api/v1/students/activities/todo`, { params })
}

function getArchivedActivities({ student }, {}, params) {
    return axios.get(`api/v1/students/${student}/activities/archived`, {
        params,
    })
}

function restoreArchivedActivities({ student }, formData) {
    return axios.post(`api/v1/students/${student}/activities/restore`, formData)
}

function lockActivityV2({ id }, formData) {
    return axios.post(`api/v2/activities/${id}/lock`, formData)
}

function updateChrono({ id }, formData) {
    return axios.post(`api/activities/${id}/update-chrono`, formData)
}

function generateMaterials({}, formData) {
    return axios.post(`api/v2/materials/generate`, formData)
}

function generateMaterialsSkillsPart1({}, formData) {
    return axios.post(`api/v2/materials/generate`, {
        ...formData,
        skills_part: 1,
    })
}

function generateMaterialsSkillsPart2({}, formData) {
    return axios.post(`api/v2/materials/generate`, {
        ...formData,
        skills_part: 2,
    })
}

function generateMaterialsSkillsPart3({}, formData) {
    return axios.post(`api/v2/materials/generate`, {
        ...formData,
        skills_part: 3,
    })
}

function generatePropositionConceptReview({ materialId }, formData) {
    return axios.post(`api/v2/materials/${materialId}/generate-proposition`, {
        ...formData,
        proposition_type: "concept_review",
        order: 1,
    })
}

function generatePropositionMethodReview({ materialId }, formData) {
    return axios.post(`api/v2/materials/${materialId}/generate-proposition`, {
        ...formData,
        proposition_type: "method_review",
        order: 2,
    })
}

function generatePropositionFirstSubExercise({ materialId }, formData) {
    return axios.post(`api/v2/materials/${materialId}/generate-proposition`, {
        ...formData,
        proposition_type: "first_sub_exercise",
        order: 3,
    })
}

function generateSimilarExercisesMoreDifficult({}, formData) {
    return axios.post(`api/v2/materials/similar-exercises`, {
        ...formData,
        variation_type: "more_difficult",
    })
}
function generateSimilarExercisesSameDifficulty({}, formData) {
    return axios.post(`api/v2/materials/similar-exercises`, {
        ...formData,
        variation_type: "same_difficulty",
    })
}
// Same difficulty, but diversified exercise_type/context relative to the source.
// Distinct service name so useApiStatus can route the response to the right card.
function generateSimilarExercisesSameDifficultyDiversified({}, formData) {
    return axios.post(`api/v2/materials/similar-exercises`, {
        ...formData,
        variation_type: "same_difficulty",
        diversify: true,
    })
}
function generateSimilarExercisesOtherConcepts({}, formData) {
    return axios.post(`api/v2/materials/similar-exercises`, {
        ...formData,
        variation_type: "other_concepts",
    })
}

function createActivityAsTutor({ id }, formData) {
    return axios.post(`api/v2/students/${id}/activities/todo`, formData)
}

// Material Feedback functions
function getMaterialFeedback({ material_id, feature_type }) {
    return axios.get("api/material-feedback", {
        params: { material_id, feature_type },
    })
}

function submitMaterialFeedback({
    material_id,
    feedback_type,
    feature_type,
    comment,
}) {
    return axios.post("api/material-feedback", {
        material_id,
        feedback_type,
        feature_type,
        comment,
    })
}

// Material Visual Explanation functions
function generateVisualExplanation({ material_id }) {
    return axios.post(
        `api/materials/${material_id}/generate-visual-explanation`
    )
}

// « Réessayer » de l'aide à la correction (corrigé de référence)
function retryMaterialCorrection({ material_id }) {
    return axios.post(`api/materials/${material_id}/retry-correction`)
}

// Prerequisite Quiz functions
function getPrerequisiteQuiz({ activityId }) {
    return axios.get(`api/v1/activities/${activityId}/quiz`)
}

function getPrerequisiteQuizStatus({ activityId }) {
    return axios.get(`api/v1/activities/${activityId}/quiz/status`)
}

function submitPrerequisiteQuizAttempt({ activityId }, formData) {
    return axios.post(`api/v1/activities/${activityId}/quiz/attempt`, formData)
}

function giveQuizFeedback({ activityId }, data) {
    return axios.post(`api/v1/activities/${activityId}/quiz/feedback`, data)
}

// « Retirer le quiz » : le masteur retire le quiz avant la tentative de l'élève.
function deletePrerequisiteQuiz({ activityId }) {
    return axios.delete(`api/v1/activities/${activityId}/quiz`)
}

// Une réponse au défi joué pendant que Sam corrige la copie.
function answerCorrectionWait({ activityId }, data) {
    return axios.post(`api/activities/${activityId}/correction-wait/answers`, data)
}

// Quiz Question Signal functions
function signalQuizQuestion({ activityId }, data) {
    return axios.post(`api/v1/activities/${activityId}/quiz/signal`, data)
}

// Activity Correction Feedback functions (polymorphic)
function getActivityCorrectionFeedback({ activityId }) {
    return axios.get("api/feedbacks", {
        params: {
            feedbackable_type: "activity",
            feedbackable_id: activityId,
            feature_type: "correction",
        },
    })
}

function submitActivityCorrectionFeedback({}, { activityId, feedbackType, comment }) {
    return axios.post("api/feedbacks", {
        feedbackable_type: "activity",
        feedbackable_id: activityId,
        feedback_type: feedbackType,
        feature_type: "correction",
        comment,
    })
}

export const activitiesService = {
    getActivities,
    pollActivityCorrection,
    getFinishedActivities,
    readReview,
    getStudentFinishedActivities,
    initActivity,
    postActivityLogs,
    postActivityLog,
    postActivityLogV1,
    finalizeActivity,
    finalizeActivitySilent,
    getActivitiesForReview,
    reviewActivity,
    reviewLock,
    activityTodoAsStudent,
    activityTodoAsTutor,
    activityTodoForStudents,
    updateActivityTodo,
    activityTodoIndexesAsStudent,
    activityTodoIndexesAsTutor,
    deleteCommonActivityTodo,
    postMaterial,
    putMaterial,
    deleteMaterial,
    getMaterial,
    lockActivity,
    getActivity,
    deleteActivitiesTodo,
    lockActivityV2,
    updateChrono,
    deleteActivityLog,
    materialsSearch,
    tutorValidateActivity,
    generateMaterials,
    generateMaterialsSkillsPart1,
    generateMaterialsSkillsPart2,
    generateMaterialsSkillsPart3,
    generatePropositionConceptReview,
    generatePropositionMethodReview,
    generatePropositionFirstSubExercise,
    generateSimilarExercisesMoreDifficult,
    generateSimilarExercisesSameDifficulty,
    generateSimilarExercisesSameDifficultyDiversified,
    generateSimilarExercisesOtherConcepts,
    createActivityAsTutor,
    // Material feedback
    getMaterialFeedback,
    submitMaterialFeedback,
    // Material visual explanation
    generateVisualExplanation,
    // Material correction
    retryMaterialCorrection,
    getArchivedActivities,
    restoreArchivedActivities,
    // Prerequisite quiz
    getPrerequisiteQuiz,
    getPrerequisiteQuizStatus,
    submitPrerequisiteQuizAttempt,
    giveQuizFeedback,
    deletePrerequisiteQuiz,
    // Quiz question signals
    signalQuizQuestion,
    answerCorrectionWait,
    // Activity correction feedback
    getActivityCorrectionFeedback,
    submitActivityCorrectionFeedback,
}
